/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { memo, useEffect, useRef, useState } from 'react';
import { useTimer, useStopwatch } from 'react-timer-hook';
import { useSelector } from 'react-redux';
import moment from 'moment';

const ExtensionTimer = () => {
    const extensionDetails = useSelector(
        state => state.conf.timerExtensionDetails,
    );
    const backgdColor = extensionDetails?.colorTheme === undefined || extensionDetails?.colorTheme === 'whiteOnBlack' ? 'bg-black' : 'bg-white';
    const [timerBackground, setTimerBackground] = useState(backgdColor);
    const [timerViewMessage, setTimerViewMessage] = useState('Timer');
    const [showTimerLabel, setShowTimerLabel] = useState(false);
    const [showTime, setShowTime] = useState(true);
    const [showLabel, setShowLabel] = useState(true);
    const [showTimer, setShowTimer] = useState(true);
    const screenDimension = useSelector((state) => state.conf.screenDimension);
    const { screenHeight, screenWidth } = screenDimension;

    const { textColor } = extensionDetails || {};

    console.log('extensionDetails', extensionDetails);
    useEffect(() => {
        if (backgdColor) {
            setTimerBackground(backgdColor);
            setTimerViewMessage('Timer');
        }
    }, [backgdColor, extensionDetails?.id]);

    const timerMessage =
        extensionDetails.goodMessage ||
            extensionDetails.warningMessage ||
            extensionDetails.wrapUpMessage
            ? true
            : false;

    // function timerConditions(totalSeconds) {
    //     if (
    //         extensionDetails.goodMessage &&
    //         totalSeconds === extensionDetails.goodSeconds
    //     ) {
    //         setTimerBackground('timer-good-bg');
    //         setTimerViewMessage(extensionDetails.goodText);
    //     }

    //     if (
    //         extensionDetails.warningMessage &&
    //         totalSeconds === extensionDetails.warningSeconds
    //     ) {
    //         setTimerBackground('timer-warn-bg');
    //         setTimerViewMessage(extensionDetails.warningText);
    //     }

    //     if (
    //         extensionDetails.wrapUpMessage &&
    //         totalSeconds === extensionDetails.wrapupSeconds
    //     ) {
    //         setTimerBackground('timer-wrap-bg');
    //         setTimerViewMessage(extensionDetails.wrapupText);
    //     }
    // }

    function timerConditions(totalSeconds) {
        if (
            extensionDetails.goodMessage &&
            (extensionDetails.type.toLowerCase() === 'down'
                ? totalSeconds <= extensionDetails.goodSeconds
                : totalSeconds >= extensionDetails.goodSeconds)
        ) {
            setTimerBackground('timer-good-bg');
            setTimerViewMessage(extensionDetails.goodText);
        } if (
            extensionDetails.warningMessage &&
            (extensionDetails.type.toLowerCase() === 'down'
                ? totalSeconds <= extensionDetails.warningSeconds
                : totalSeconds >= extensionDetails.warningSeconds)
        ) {
            setTimerBackground('timer-warn-bg');
            setTimerViewMessage(extensionDetails.warningText);
        } if (
            extensionDetails.wrapUpMessage &&
            (extensionDetails.type.toLowerCase() === 'down'
                ? totalSeconds <= extensionDetails.wrapupSeconds
                : totalSeconds >= extensionDetails.wrapupSeconds)
        ) {
            setTimerBackground('timer-wrap-bg');
            setTimerViewMessage(extensionDetails.wrapupText);
        }
    }

    const time = new Date();
    time.setSeconds(time.getSeconds() + extensionDetails.seconds);

    const getDimension = (value, total) =>
        (total * (value > 100 || value < 0 ? 100 : value)) / 100;

    const shouldHideExtension = () => {
        return !extensionDetails.visible_to_guest;
    };

    const isSidebarOpen = false;
    const handlerStyle = {
        height: `${getDimension(extensionDetails.height, screenHeight)}px`,
        width:
            extensionDetails?.fullScreen && isSidebarOpen
                ? 'calc(100vw - 20.6em)'
                : extensionDetails?.fullScreen
                    ? '100vw'
                    : `198.6px`,
        top: extensionDetails?.fullScreen
            ? 'auto'
            : `${getDimension(extensionDetails?.top, screenHeight)}px`,
        bottom: 'auto',
        left:
            extensionDetails?.fullScreen && isSidebarOpen
                ? '-11px'
                : `${getDimension(extensionDetails?.left, screenWidth)}px`,
        position: 'absolute',
        opacity: 1,
        display: shouldHideExtension() ? 'none' : '',
        zIndex: 1,
    };


    return (
        <div
            style={handlerStyle}
            className={` ${extensionDetails?.fullScreen && 'full-screen-timer'
                } timer-close `}>
            <div className={`meeting_time_container
        ${isSidebarOpen && extensionDetails.fullScreen
                    ? 'full-screen-width border-radius'
                    : extensionDetails.fullScreen && 'full-width border-radius'
                }
      `}>
                <div
                    className={`meeting_time border ${timerBackground} ${textColor === undefined ? 'text-white' : textColor
                        }`}
                    style={{ display: showTimer ? '' : 'none' }}>
                    <div className="d-flex justify-content-center flex-column w-100 h-100">
                        <div className="d-flex align-items-center justify-content-center position-relative">
                            <div style={{ display: showTime ? '' : 'none' }}>
                                {extensionDetails.type.toLowerCase() === 'down' ? (
                                    <DownTimer
                                        expiryTimestamp={time}
                                        extensionDetails={extensionDetails}
                                        timerConditions={timerConditions}
                                        timerMessage={timerMessage}
                                        hideForAll={() => { }}
                                    />
                                ) : (
                                    <UpTimer
                                        extensionDetails={extensionDetails}
                                        timerConditions={timerConditions}
                                        timerMessage={timerMessage}
                                        widgetid={extensionDetails?.id}
                                    />
                                )}
                            </div>

                        </div>
                        <small
                            className="justify-content-center"
                            style={{
                                cssText: `color: ${textColor === 'text-white' || textColor === undefined
                                    ? '#FFFFFF'
                                    : '#000000'
                                    } !important`,
                            }}>
                            {showLabel ? timerViewMessage : ''}
                        </small>
                    </div>
                </div>

                <div>
                    {/* <a
                        className="meeting_time_menu_btn"
                        onClick={() => {
                            setShowTimerLabel(!showTimerLabel);
                        }}>
                        <svg width="100%" viewBox="10 4 4 16">
                            <path fill="#ffffff" d="M10 10h4v4h-4zm0-6h4v4h-4zm0 12h4v4h-4z" />
                        </svg>
                    </a> */}
                    {showTimerLabel && (
                        <div className="meeting_time_menu_options">
                            <label className="checkwrap">
                                Show Time
                                <input
                                    spellCheck="false"
                                    type="checkbox"
                                    id="showTime"
                                    name="showTime"
                                    onChange={() => {
                                        setShowTime(!showTime);
                                    }}
                                    checked={showTime}
                                />
                                <span className="checkmark" />
                            </label>
                            <label className="checkwrap">
                                Show Label
                                <input
                                    spellCheck="false"
                                    type="checkbox"
                                    id="showLabel"
                                    name="showLabel"
                                    onChange={() => {
                                        setShowLabel(!showLabel);
                                    }}
                                    checked={showLabel}
                                />
                                <span className="checkmark" />
                            </label>
                            <label className="checkwrap">
                                Show Timer
                                <input
                                    spellCheck="false"
                                    type="checkbox"
                                    id="showTimer"
                                    name="showTimer"
                                    onClick={() => {
                                        setShowTimer(!showTimer);
                                    }}
                                    checked={showTimer}
                                />
                                <span className="checkmark" />
                            </label>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const DownTimer = ({
    expiryTimestamp,
    extensionDetails,
    timerConditions,
    timerMessage,
    hideForAll,
}) => {
    const { seconds, minutes, totalSeconds, start, pause, resume, restart } = useTimer({
        expiryTimestamp,
        onExpire: () => console.warn('onExpire called'),
    });

    const firstRender = useRef(true);

    if (extensionDetails?.hideAtZero && totalSeconds === 0) {
        hideForAll();
    }

    const formattedMinutes = minutes.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
    });

    const formattedSeconds = seconds.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
    });

    const timerStatus = extensionDetails.status.toLowerCase();

    useEffect(() => {
        if (timerStatus === 'start') {
            start();
        } else if (timerStatus === 'pause') {
            pause();
        } else if (timerStatus === 'resume') {
            // const time = new Date();
            // time.setSeconds(
            //   time.getSeconds() + extensionDetails.timer_resume_seconds,
            // );
            // restart(time);
            resume();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timerStatus]);

    //Recreate timer if timer_start or seconds change
    useEffect(() => {
        const newUtc = moment().utc().valueOf();
        let newDiff = 0;

        if (extensionDetails?.timer_start < newUtc) {
            newDiff = moment
                .duration(newUtc - extensionDetails.timer_start)
                .asSeconds();
        }

        const newExpiry = new Date();
        newExpiry.setSeconds(
            newExpiry.getSeconds() + (extensionDetails.seconds - newDiff),
        );

        restart(newExpiry); // <-- Important: re-sync timer
    }, [extensionDetails?.timer_start, extensionDetails?.seconds, restart]);

    useEffect(() => {
        if (timerMessage) {
            console.log(timerMessage, 'timerMessage');
            timerConditions(totalSeconds);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timerMessage, seconds]);

    return (
        <div>
            <div className={`${extensionDetails.fullScreen ? 'timer-font-size' : ''}`}>
                <span>{formattedMinutes}</span>:<span>{formattedSeconds}</span>
            </div>
        </div>
    );
};

const UpTimer = ({ extensionDetails, timerConditions, timerMessage, widgetid, }) => {
    const utcTimestamp = moment().utc().valueOf();
    const timer_start = extensionDetails?.timer_start;
    let difference = 0;

    if (timer_start < utcTimestamp) {
        difference = moment.duration(utcTimestamp - timer_start).asSeconds();
    }

    let stopwatchOffset = new Date();
    stopwatchOffset.setSeconds(stopwatchOffset.getSeconds() + difference);

    const { seconds, minutes, totalSeconds, start, pause, reset } = useStopwatch({
        autoStart: true,
        offsetTimestamp: stopwatchOffset,
    });

    useEffect(() => {
        if (timerMessage) {
            timerConditions(totalSeconds);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timerMessage, totalSeconds]);

    const formattedMinutes = minutes.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
    });

    const formattedSeconds = seconds.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
    });

    const timerStatus = extensionDetails.status.toLowerCase();

    useEffect(() => {
        if (timerStatus === 'start' || timerStatus === 'resume') {
            start();
        } else if (timerStatus === 'pause') {
            pause();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timerStatus]);
    useEffect(() => {
        console.log('extensionDetails?.id', extensionDetails?.id);
        if (extensionDetails?.id) {
            const newExpiry = new Date();
            reset(newExpiry);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [extensionDetails?.id]);

    return (
        <div>
            <div
                className={`${extensionDetails.fullScreen ? 'timer-font-size' : ''}`}>
                <span>{formattedMinutes}</span>:<span>{formattedSeconds}</span>
            </div>
        </div>
    );
};

export default memo(ExtensionTimer);
